import { titleTypography } from "shared/styles/style"

export const styleSelect = ({ breakpoints, functions: { pxToRem } }) => ({
  height: "100%",
  minWidth: "160px",
  "& *": {
    fontFamily: "'Lexend', san-serif !important",
  },
  "& .MuiOutlinedInput-root": {
    paddingTop: "4px",
    paddingBottom: "4px",
  },
  "& input, & input::placeholder": {
    fontSize: "12px !important",
    lineHeight: "1.5!important",
    fontWeight: 400,
    fontFamily: "Lexend",
  },

  "& input": {
    paddingLeft: `14px !important`,
    padding: "8px",
  },

  "& input.MuiSelect-select": {
    padding: "10px !important",
  },
  "& .MuiInputBase-input": {
    paddingLeft: `14px !important`,
    padding: "10px !important",
    minHeight: "20.25px !important",
  },
})
export const customStyleDropDown = () => ({
  height: "100%",
  minWidth: "160px",
  "& *": {
    fontFamily: "'Lexend', san-serif!important",
  },
  "&.MuiOutlinedInput-root": {
    paddingTop: "4px",
    paddingBottom: "4px",
  },
  "& input, & input::placeholder": {
    fontSize: "12px!important",
    lineHeight: "1.5!important",
    fontWeight: 400,
    fontFamily: "Lexend",
  },

  "& input": {
    paddingLeft: `14px!important`,
    padding: "5px",
  },

  "& .MuiAutocomplete-inputRoot": {
    padding: "4.5px !important",
  },
})
export const studentAtRiskStyle = ({
  breakpoints,
  palette,
  functions: { pxToRem },
}) => ({
  boxShadow: "0 0 12px 0 rgba(0, 0, 0, 0.06)",
  backgroundColor: palette.white.main,
  borderRadius: pxToRem(12),
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  height: "auto",
})
export const studentAtRiskTitleStyle = ({
  breakpoints,
  typography,
  functions: { pxToRem },
}) => ({
  ...titleTypography(breakpoints),
  lineHeight: 1.37,
  letterSpacing: pxToRem(-0.8),
  // minWidth: 200,
  paddingRight: "5px",
  width: "fit-content",
})

export const tableWrapperStyle = ({ breakpoints }) => ({
  // height: "70%",
  "& thead th div": {
    fontWeight: 600,
    textTransform: "uppercase",
    fontSize: "14px",
    color: "#172B4D",
    opacity: 1,
  },
  "& tbody tr td div, & tbody tr td div p": {
    fontSize: "14px",
    color: "#172B4D",
  },
  [breakpoints.down("lg")]: {
    rowGap: 2,
  },
})

export const chipStyle = ({ breakpoints }) => ({
  borderRadius: "8px",
  background: "#1AAE6F1A !important",
  borderColor: "#1AAE6F !important",
  color: "#1AAE6F !important",
})
export const offtrackStyle = ({ breakpoints }) => ({
  background: "#EF39481A !important",
  borderColor: "#EF3948 !important",
  color: "#EF3948 !important",
})
export const actionButtonStyle = ({ breakpoints }) => ({
  fontSize: "14px",
  fontWeight: 400,
  textTransform: "none !important",
  gap: "6px",
  display: "flex",
  alignItems: "center",
  borderRadius: "8px",
  backgroundColor: "#EAF3FB !important",
  color: "#2A63F6 !important",
})
